import axios from "axios";

const loadInvoices = (obj) => {
    /*
        Requisição: Envia mês e ano para filtragem. Qual padrão você prefere receber nos filtros?
        Ex: janeiro: 0, fevereiro, 1?
        Retorna: Array de JSONs no padrão:
        {
            datetime: '07/08/2024 09:51:35',
            number: 1,
            customer: {
                pk: null,
                name: 'Cliente teste',
                cpf_cnpj: '123.456.789-10',
                email: '',
            },
            service: {
                description: "Prestação de serviços referente a Agosto de 2024.",
                value: 8398.01,
            }
            status: "emitida"
        }
    */
    return axios.get('/financial/invoices/', obj)
}

const getInvoice = (number) => {
    /*
    Requisição: Envia o número da nota
    Retorna: JSON de todas as informações da nota
    */
    return axios.get('/financial/invoices/' + number + '/')
    .then((response) => response.data)
}

const issueInvoice = async (obj) => {
    let bodyFormData = new FormData();
    bodyFormData.append('obj', JSON.stringify(obj));
    /*
    Requisição: Envia um JSON com as informações da nota a ser emitida, no padrão:
    Obs, esse padrão segue o mesmo padrão do formato da API. Só precisa atribuir os campos de acordo

    {
        datetime: '',
        customer:{
            pk,
         }'',
        service: {
            value: '',
            description: '',
        }
    },

    Retorna: Status da chamada para a API
    */
    const response = await axios.post('/financial/invoices/issue_invoice/', bodyFormData);
    return response;
}

const consultInvoice = (number) => {
    /*
    Requisição: Envia o número da nota
    Retorna: Status da chamada para a API
    */
    return axios.get('/financial/invoices/' + number + '/status/')
    .then((response) => response.data)
}

const cancelInvoice = (number) => {
    /*
    Requisição: Envia o número da nota
    Retorna: Status da chamada para a API
    {
      justification: 'Motivo da cancelamento'
    }
    */
    return axios.get('/financial/invoices/' + number + '/cancel/')
    .then((response) => response.data)
}

const seeInvoice = (number) => {
    /*
    Requisição: Envia o número da nota
    Retorna: url para a visualização da nota (obtida no retorno da criação da nota pela API) /
    precisamos ver como é a visualização da nota fiscal pela URL depois de ser gerada. Se é possível essa
    visualização fácil.
    */
    return axios.get('/financial/invoices/' + number + '/url/')
    .then((response) => response.data)
}

export default {
    loadInvoices,
    getInvoice,
    issueInvoice,
    consultInvoice,
    cancelInvoice,
    seeInvoice
}
